import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Avatar, AvatarFallback } from '@/components/ui/avatar'
import { User, Mail, Calendar, Shield } from 'lucide-react'
import { PageWrapper } from '@/components/animated/page-wrapper'

export function Profile() {
  const navigate = useNavigate()
  return (
    <PageWrapper>
      <div className="space-y-6 bg-gray-50 dark:bg-background min-h-screen -m-6 p-6">
        <div className="max-w-4xl mx-auto space-y-6">
          {/* Header */}
          <div>
            <h1 className="text-3xl font-light tracking-tight text-foreground">Profil</h1>
            <p className="text-sm text-muted-foreground mt-1">
              Verwalte deine persönlichen Informationen
            </p>
          </div>

          {/* Profile Card */}
          <Card>
            <CardHeader>
              <div className="flex items-center space-x-4">
                <Avatar className="h-20 w-20">
                  <AvatarFallback className="text-2xl">
                    <User className="h-10 w-10" />
                  </AvatarFallback>
                </Avatar>
                <div>
                  <CardTitle>Benutzerprofil</CardTitle>
                  <CardDescription>
                    Aktualisiere deine Profilinformationen
                  </CardDescription>
                </div>
              </div>
            </CardHeader>
            <CardContent className="space-y-6">
              {/* Name */}
              <div className="grid gap-2">
                <Label htmlFor="name">Name</Label>
                <Input
                  id="name"
                  placeholder="Dein Name"
                  defaultValue="Admin User"
                />
              </div>

              {/* Email */}
              <div className="grid gap-2">
                <Label htmlFor="email">E-Mail</Label>
                <Input
                  id="email"
                  type="email"
                  placeholder="deine@email.de"
                  defaultValue="admin@missionsolar.de"
                />
              </div>

              {/* Role (read-only) */}
              <div className="grid gap-2">
                <Label htmlFor="role">Rolle</Label>
                <div className="flex items-center space-x-2 text-sm text-muted-foreground">
                  <Shield className="h-4 w-4" />
                  <span>Administrator</span>
                </div>
              </div>

              {/* Member since (read-only) */}
              <div className="grid gap-2">
                <Label htmlFor="member-since">Mitglied seit</Label>
                <div className="flex items-center space-x-2 text-sm text-muted-foreground">
                  <Calendar className="h-4 w-4" />
                  <span>September 2024</span>
                </div>
              </div>

              {/* Actions */}
              <div className="flex justify-end space-x-2 pt-4">
                <Button variant="outline" onClick={() => navigate('/dashboard')}>
                  Abbrechen
                </Button>
                <Button>Änderungen speichern</Button>
              </div>
            </CardContent>
          </Card>

          {/* Password Change Card */}
          <Card>
            <CardHeader>
              <CardTitle>Passwort ändern</CardTitle>
              <CardDescription>
                Aktualisiere dein Passwort für mehr Sicherheit
              </CardDescription>
            </CardHeader>
            <CardContent className="space-y-4">
              <div className="grid gap-2">
                <Label htmlFor="current-password">Aktuelles Passwort</Label>
                <Input id="current-password" type="password" />
              </div>

              <div className="grid gap-2">
                <Label htmlFor="new-password">Neues Passwort</Label>
                <Input id="new-password" type="password" />
              </div>

              <div className="grid gap-2">
                <Label htmlFor="confirm-password">Passwort bestätigen</Label>
                <Input id="confirm-password" type="password" />
              </div>

              <div className="flex justify-end pt-2">
                <Button>Passwort ändern</Button>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </PageWrapper>
  )
}
